import { Image } from './common';

export interface VerificationResponse {
  tmpCode: string;
  codeSent: boolean;
}

export interface AuthToken {
  accessToken: string;
  expiresAt: string;
  refreshToken: string;
  refreshTokenExpiresAt: string;
}

export interface User {
  id: string;
  birthday: string;
  countryIsoCode: string;
  email: string;
  feedGenderPreference: string;
  firstName: string;
  image?: Image;
  lastName?: string;
  phoneNumber: string;
  role: BooklaRole;
}

export interface UserAuth {
  token: AuthToken;
  user: User;
}

export enum GenderPreference {
  Both = 'both',
  Female = 'female',
  Male = 'male',
}

export interface UserRegistrationData {
  code: string;
  countryIsoCode: string;
  email?: string;
  feedGenderPreference: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  password: string;
}

export enum BooklaRole {
  User = 0,
  Admin = 1,
  Moderator = 2,
}
